'use client'

import { ButtonIconTransparent } from 'fukku/Button/Icon/Transparent'
import { MODAL_TYPE, Modal, type ModalAPI } from 'fukku/Modal'
import { IconQr } from 'icons/components/IconQr'
import { useLabels } from 'labels/hooks/useLabels/useLabels'
import { useMasterData } from 'master-data/hooks/useMasterData/useMasterData'
import dynamic from 'next/dynamic'
import { useLayoutEffect, useRef, useState } from 'react'

import styles from './ModalUserInfo.module.scss'

const ModalContent = dynamic(() =>
	import('./ModalContent/ModalContent').then((mod) => mod.ModalContent)
)

export const ModalUserInfo = ({ userName }: { readonly userName: string }) => {
	const modalRef = useRef<ModalAPI>(null)
	const { t } = useLabels()
	const [loadModal, setLoadModal] = useState(false)
	const { isShop } = useMasterData()

	useLayoutEffect(() => {
		modalRef.current?.show()
	}, [loadModal])

	const onClick = () => {
		setLoadModal(true)
	}

	const handleClose = () => {
		setLoadModal(false)
	}

	return (
		isShop && (
			<div>
				<div className={styles.iconContainer}>
					<ButtonIconTransparent
						onClick={onClick}
						data-testid='myAccount.modalUserInfo.iconQr'
					>
						<IconQr alt={t('accessibility.icon.ID.text')} />
					</ButtonIconTransparent>
				</div>
				{loadModal && (
					<Modal
						ref={modalRef}
						name='myAccount-user-info-modal'
						type={MODAL_TYPE.SHEET}
						title={userName}
						onClose={handleClose}
						className={styles.modal}
					>
						<ModalContent userName={userName} />
					</Modal>
				)}
			</div>
		)
	)
}
